import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const XIconDef = {
  x: makeIconDef('x', {
    regular: () => <path d="M20 4L4 20M4 4L20 20" stroke="currentColor" strokeWidth="2" fill="currentColor" />,
  })
}